import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { Route, Routes } from 'react-router-dom';
import TopBar from 'components/layout/topbar/topbar';
import RunsUsageBanner from 'components/layout/runs-usage-banner';
import NewLookBanner from 'components/new-look-banner/new-look-banner';
import NewLookModal from 'components/new-look-modal/new-look-modal';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import { css } from '@emotion/react';

export const MainLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <OuterContainer>
      <RunsUsageBanner />
      <Routes>
        {['/p/:projectId/*', '/*'].map(path => (
          <Route key={path} path={path} element={<TopBar page={path} />} />
        ))}
      </Routes>
      <BannerStack>
        <NewLookBanner />
      </BannerStack>
      <MainLayoutContainer>{children}</MainLayoutContainer>
      <NewLookModal />
    </OuterContainer>
  );
};

export const BannerStack = styled.div`
  display: flex;
  flex-direction: column;
  ${legacyOnly(css`
    gap: 2px;
  `)}
  ${newDesignOnly(css`
    gap: var(--spacing-xxxxs);
  `)}
`;

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryWhite};
  flex: 1;
  max-height: 100%;
  overflow: hidden;
`;

export default MainLayout;
